import 'component/css/paginator.css';

import React from 'react';

class Paginator extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = { page: props.page || 1 };
    this.page_click = this.page_click.bind(this);
  }

  page_click(page) { this.setState({page}); this.props.onSetPage(page); }

  renderButton(page, text) {
    if (page == this.state.page) {
      return <button key={`p${text||page}`} className="btn-page selected" type="button">{text||page}</button>;
    } else {
      return <button key={`p${text||page}`} className="btn-page" type="button" onClick={e => this.page_click(page)}>{text||page}</button>;
    }
  }

  render()
  {
    let pN = Math.ceil(this.props.itemsCount / this.props.pageCount);
    let elms = [];
    if (pN > 10)
    { // show 3+P+3
      let a = this.state.page - 3;
      let b = this.state.page + 3;
      if (a <  1) { a =  1; b = 7; }
      if (b > pN) { b = pN; a = pN - 7; }
      for (let i = a; i <= b; i++)
      { elms.push(this.renderButton(i)); }

      if (this.state.page >  1) elms.unshift(this.renderButton( 1, '<<'));
      if (this.state.page < pN) elms.push(this.renderButton(pN, '>>'));

    } else {
      // show all 10
      for (let i = 1; i <= pN; i++)
      { elms.push(this.renderButton(i)); }
    }

    return (<nav className="paginator">{ elms }</nav>);
  }
}

export default Paginator;